<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-modal ref="modal" :title="title" no-close-on-backdrop @ok="ok($event)" @cancel="close()" @close="close()">
        <div class="edit-plot-content">
            <div v-if="plot.id" class="edit-plot-line">
                <div class="edit-plot-label">ID：</div>
                <div class="edit-plot-value">{{plot.id}}</div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">名称：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.name"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">类型：</div>
                <div class="edit-plot-input">
                    <select class="form-control" v-model="plot.type">
                        <option v-for="type in plotTypes" :key="type.id" :value="type.type">{{type.type}}</option>
                    </select>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">泊位名称：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.berth"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">所属河流：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.river"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">里程刻度：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.cursor"/></div>
            </div>
        </div>
        <hr/>
        <div class="edit-plot-content">
            <div class="edit-plot-line">
                <div class="edit-plot-label">码头属性</div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">货品：</div>
                <div class="edit-plot-input"><input class="form-control" v-model="plot.cargo"/></div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">装卸货：</div>
                <div class="edit-plot-input edit-plot-value-line">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-load" v-model="plot.load"/>
                        <label class="custom-control-label" for="check-load">装货</label>
                    </div>
                    <div class="ml-3 custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-unload" v-model="plot.unload"/>
                        <label class="custom-control-label" for="check-unload">卸货</label>
                    </div>
                    <div class="edit-plot-value-line-dummy"></div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">船舶吨位：</div>
                <div class="edit-plot-input">
                    <div class="d-flex align-items-center">
                        <input class="form-control" v-model="plot.minWeight"/>
                        <span class="mx-2">~</span>
                        <input class="form-control" v-model="plot.maxWeight"/>
                    </div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">作业限制：</div>
                <div class="edit-plot-input edit-plot-value-line">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-max-length" v-model="maxLength">
                        <label class="custom-control-label" for="check-max-length">船长不超过</label>
                    </div>
                    <input style="flex: 1" class="form-control" v-model="plot.maxLength" :disabled="!maxLength"/>
                    <div>米</div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label"></div>
                <div class="edit-plot-input edit-plot-value-line">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-max-width" v-model="maxWidth">
                        <label class="custom-control-label" for="check-max-width">船宽不超过</label>
                    </div>
                    <input style="flex: 1" class="form-control" v-model="plot.maxWidth" :disabled="!maxWidth"/>
                    <div>米</div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label"></div>
                <div class="edit-plot-input edit-plot-value-line">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-max-draught" v-model="maxDraught">
                        <label class="custom-control-label" for="check-max-draught">吃水不超过</label>
                    </div>
                    <input style="flex: 1" class="form-control" v-model="plot.maxDraught" :disabled="!maxDraught"/>
                    <div>米</div>
                </div>
            </div>
            <div class="edit-plot-line">
                <div class="edit-plot-label">备注：</div>
                <div class="edit-plot-textarea">
                    <textarea rows="3" class="form-control" v-model="plot.memo"></textarea>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <div class="w-100 d-flex align-items-center justify-content-between m-0">
                <div>
                    <b-button v-if="isEdit" class="m-1" variant="danger" @click="remove()">删除标绘</b-button>
                </div>
                <div>
                    <b-button v-if="isEdit" class="m-1" variant="warning" @click="redraw()">重画标绘</b-button>
                </div>
                <div class="form-inline">
                    <b-button class="m-1" variant="outline-primary" @click="cancel()">取消</b-button>
                    <b-button class="m-1" variant="primary" @click="ok()">确定</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {plotTypes} from "../olMap/featureUtils";
import User from "@/services/user";
import * as MsgBox from "@/utils/msgBox";
import Plot from "@/services/plot";

const defaultPlot = {
    name: "",
    type: "码头",
    load: true,
    unload: true,
};

const getIntValue = x => Number.isFinite(Number.parseInt(x)) ? Number.parseInt(x) : null;
const getIntString = x => Number.isFinite(Number.parseInt(x)) ? Number.parseInt(x) : "";

export default {
    name: "EditLinePlotDialog",
    data() {
        return {
            plot: defaultPlot,
            plotTypes: [],
            maxLength: false,
            maxWidth: false,
            maxDraught: false,
        };
    },
    computed: {
        isEdit() {
            return this.plot && this.plot.id;
        },
        isAdmin() {
            return User.user && User.user.admin;
        },
        title() {
            return (this.isEdit ? "编辑" : "新建") + "线标绘";
        },
    },
    methods: {
        modal(plot) {
            this.plotTypes = plotTypes.filter(
                x => x.category === "line" && (this.isAdmin ? x.adminEditable : x.userEditable)
            );
            this.points = plot.points;
            this.rowVersion = plot.rowVersion;
            this.maxLength = Number.isFinite(plot.maxLength);
            this.maxWidth = Number.isFinite(plot.maxWidth);
            this.maxDraught = Number.isFinite(plot.maxDraught);
            this.plot = plot ? {
                id: plot.id || 0,
                name: plot.name || defaultPlot.name,
                type: plot.type || defaultPlot.type,
                berth: plot.berth || "",
                river: plot.river || "",
                cursor: plot.cursor || "",
                cargo: plot.cargo || "",
                load: plot.load === void(0) || plot.load === null ? defaultPlot.load : (plot.load || false),
                unload: plot.unload === void(0) || plot.unload === null ? defaultPlot.unload : (plot.unload || false),
                minWeight: getIntString(plot.minWeight),
                maxWeight: getIntString(plot.maxWeight),
                maxLength: getIntString(plot.maxLength),
                maxWidth: getIntString(plot.maxWidth),
                maxDraught: getIntString(plot.maxDraught),
                memo: plot.memo || "",
            } : Object.assign({}, defaultPlot);
            return new Promise(resolve => {
                this.resolve = resolve;
                this.$refs.modal.show();
            });
        },
        close() {
            this.resolve && this.resolve();
        },
        async ok(e) {
            e.preventDefault();
            let plot = {
                id: this.plot.id || 0,
                name: this.plot.name || "",
                type: this.plot.type || "码头",
                points: this.points,
                rowVersion: this.rowVersion,
                berth: this.plot.berth || null,
                river: this.plot.river || null,
                cursor: this.plot.cursor || null,
                cargo: this.plot.cargo || null,
                load: this.plot.load || false,
                unload: this.plot.unload || false,
                minWeight: getIntValue(this.plot.minWeight),
                maxWeight: getIntValue(this.plot.maxWeight),
                maxLength: this.maxLength ? getIntValue(this.plot.maxLength) : null,
                maxWidth: this.maxWidth ? getIntValue(this.plot.maxWidth) : null,
                maxDraught: this.maxDraught ? getIntValue(this.plot.maxDraught) : null,
                memo: this.plot.memo || "",
            };
            if (plot.type === "码头" && !plot.load && !plot.unload) {
                return await MsgBox.alert(this, "码头属性中的装卸货必须至少选一项！");
            }
            let newId = await Plot.saveLinePlot(plot);
            if (!plot.id) {
                plot.id = newId;
            }
            this.onResult(plot);
        },
        async remove() {
            let message = `确认要删除线标绘“${this.plot.name ? this.plot.name : `ID:${this.plot.id}`}”？`;
            if (await MsgBox.confirm(this, message)) {
                await Plot.removeLinePlot(this.plot.id, this.rowVersion);
                this.onResult(null);
            }
        },
        async redraw() {
            this.onResult("redraw");
        },
        onResult(plot) {
            this.resolve && this.resolve(plot);
            this.$refs.modal.hide();
        },
    },
}
</script>

<style scoped>
.edit-plot-content > * + * {
    margin-top: 0.5rem;
}

.edit-plot-line {
    display: flex;
    align-items: stretch;
}

.edit-plot-label {
    text-align: right;
    min-width: 100px;
    margin-right: 0.5rem;
    line-height: calc(1.5em + 0.75rem + 2px);
}

.edit-plot-input {
    flex: 1;
}

.edit-plot-value {
    flex: 1;
    line-height: calc(1.5em + 0.75rem + 2px);
}

.edit-plot-value-line {
    display: flex;
    align-items: center;
}

.edit-plot-value-line > * + * {
    margin-left: 0.5rem;
}

.edit-plot-value-line-dummy {
    height: calc(1.5em + 0.75rem + 2px);
}

.edit-plot-textarea {
    width: 100%;
}
</style>
